import { memo } from 'react'
import { Button, Modal } from 'react-bootstrap'
import {
  StyledConfirmSubmitModal,
  StyledConfirmMessageBody,
  StyledExclamationMark,
  ConfirmModalBackdropStyle
} from './ConfirmSubmitModal.styled'
import { IssueTypes } from 'types/arbitrationTypes'
import { useGlobalStore } from 'store/useGlobalStore'

const PHYSICAL_SUBMIT_MESSAGE =
  'Arbitration Claims submitted without the listed supporting documents will remain invalid and will not be reviewed until all required documents are provided: Bill of Lading, Estimate, Photos, Transportation Invoice.'
const NON_PHYSICAL_SUBMIT_MESSAGE =
  'If title issue, please include scan of front/back of title and any supporting documents.'
const CONFIRM_MESSAGE = 'Are you sure you want to submit this request?'

interface IProps {
  show: boolean
  isUpdateAttachment: boolean
  issueTypeID: number
  physicalDamageMinDocuments: number
  nonPhysicalDamageMinDocuments: number
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmSubmitModal = memo(function ConfirmSubmitModal({
  show,
  isUpdateAttachment,
  issueTypeID,
  physicalDamageMinDocuments,
  nonPhysicalDamageMinDocuments,
  onConfirm,
  onCancel
}: IProps) {
  const getLocalText = useGlobalStore((state) => state.getLocalText)

  return (
    <>
      <ConfirmModalBackdropStyle />
      <StyledConfirmSubmitModal
        show={show}
        onHide={onCancel}
        backdrop="static"
        keyboard={false}
        centered
        backdropClassName="confirm-modal-backdrop"
      >
        <Modal.Header>
          <Modal.Title>{isUpdateAttachment ? 'Confirm Add Attachments' : 'Confirm Message'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StyledConfirmMessageBody>
            <StyledExclamationMark>!</StyledExclamationMark>
            {!isUpdateAttachment && issueTypeID === IssueTypes.PHYSICAL_DAMAGE && (
              <label>{getLocalText('ArbitrationPhysicalSubmitMessage', PHYSICAL_SUBMIT_MESSAGE)}</label>
            )}
            {!isUpdateAttachment && issueTypeID === IssueTypes.NON_PHYSICAL_DAMAGE && (
              <label>{getLocalText('ArbitrationNonPhysicalSubmitMessage', NON_PHYSICAL_SUBMIT_MESSAGE)}</label>
            )}
          </StyledConfirmMessageBody>
          <div className="confirm-message-label">
            {isUpdateAttachment
              ? 'Are you sure you want to add the selected attachments to this arbitration?'
              : CONFIRM_MESSAGE}
          </div>
          <div>
            <Button className="confirm-submit-btn" onClick={onConfirm}>
              {isUpdateAttachment ? 'Add' : 'Submit'}
            </Button>
            <Button className="confirm-no-btn" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </StyledConfirmSubmitModal>
    </>
  )
})
